module.exports = __webpack_public_path__ + "media/en_us_s4_Robin.f0bb8473.oga";